
const issues = {
  EMPTY: 'empty',
  MAINTENANCE: 'maintenance',
  FAILURE: 'failure'
}

export default issues